export default __webpack_public_path__ + "static/media/401.a0374749.svg";